﻿'use strict';

angular.module('ntmApp').factory('CensusProjectionFilter', ['MultiSelectFilter', 'SimpleFilter', 'RadioButtonChoiceFilter', 'Constants',
    function (MultiSelectFilter, SimpleFilter, RadioButtonChoiceFilter, Constants) {

    function CensusProjectionFilter() {

        var self = this;

        self.RoomTypeFilter = new MultiSelectFilter(Constants.DropDownBlankLabels.NoRoomType); 
        self.SpeciesFilter = new MultiSelectFilter(Constants.DropDownBlankLabels.NoSpecies);
        self.RackTypeFilter = new MultiSelectFilter(Constants.DropDownBlankLabels.NoRackType);
        self.CensusTrackingTypeFilter = new RadioButtonChoiceFilter();

        self.getfilters = function () {
            return [
                self.RoomTypeFilter,
                self.SpeciesFilter,
                self.RackTypeFilter,
                self.CensusTrackingTypeFilter
            ];
        };

        self.getAppliedFilters = function () {
            return self.getfilters().filter(function (filter) {
                return filter.isDefined();
            });
        };

        self.applied = function () {
            var filters = self.getAppliedFilters();

            if (filters) {
                return filters.length > 0;
            }

            return false;
        };

        self.isPartlyDefined = function () {
            return self.getfilters().some(function(filter) { return filter.isPartlyDefined(); });
        };

        self.clearAllFilters = function () {
            self.RoomTypeFilter.clear();
            self.SpeciesFilter.clear();
            self.RackTypeFilter.clear();
            self.CensusTrackingTypeFilter.clear();
        };

        self.filterItems = function (items) {

            var result = [];

            if (items) {

                items.forEach(function (item) {

                    if (self.RoomTypeFilter.isDefined() && !self.RoomTypeFilter.selectedItems.some(function (roomType) {
                        return (roomType.id === item.roomTypeId) || (!roomType.id && !item.roomTypeId);
                    })) {
                        return;
                    }

                    if (self.SpeciesFilter.isDefined() && !self.SpeciesFilter.selectedItems.some(function (species) {
                        return (!species.id && !item.speciesId) || (species.id === item.speciesId);
                    })) {
                        return;
                    }

                    if (self.RackTypeFilter.isDefined() && !self.RackTypeFilter.selectedItems.some(function (rackType) {
                        return (rackType.id === item.rackTypeId) || (!rackType.id && !item.rackTypeId);
                    })) {
                        return;
                    }

                    if (self.CensusTrackingTypeFilter.filterItem && self.CensusTrackingTypeFilter.filterItem !== item.censusTrackingType) {
                        return;
                    }

                    result.push(item);
                });
            }

            return result;
        };

    }

    return (CensusProjectionFilter);
}]);